import { render, staticRenderFns } from "./Departs.vue?vue&type=template&id=62783d48&scoped=true&"
import script from "./Departs.vue?vue&type=script&lang=js&"
export * from "./Departs.vue?vue&type=script&lang=js&"
import style0 from "./Departs.vue?vue&type=style&index=0&id=62783d48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62783d48",
  null
  
)

export default component.exports